module.exports = __webpack_public_path__ + "img/img-header-mobile.97d550a.webp";